import { MUTATION_TYPES } from "@/lib/const";
import { LoggedInUser, RootState } from "@/store/types";
import { ActionTree, MutationTree } from "vuex";
import { User } from "@teacherskaya/api-provider/dist/api/UserProvider";

const { STORE_DATA } = MUTATION_TYPES;
export const defaultUser: User = {
  id: "0",
  email: null,
  screenName: null,
  username: "",
  phone: "",
  role: null,
  accountInfo: {
    disabled: null,
    registrationTime: null,
    timeZone: null,
    registrationIp: null,
    lastLoginTime: null,
    lastLoginIp: null,
    referralUrl: null,
  },
  avatar: null,
  subscription: null
};

export const state = function(): LoggedInUser {
  return {
    ...defaultUser,
    authorities: [],
  };
};

export const mutations: MutationTree<LoggedInUser> = {
  [STORE_DATA]: (state, { getMyAuthorities }) => {
    state.authorities = getMyAuthorities.authorities;
  },
  setLoggedInUser: (state, { user }: { user: User }) => {
    Object.assign(state, user);
  },
};

export const actions: ActionTree<LoggedInUser, RootState> = {
  logout(context) {
    context.commit("setLoggedInUser", {
      user: defaultUser,
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
